import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import AudioCallPageGrid from "../../common/AudioCall/AudioCallGridLayout";

const ExploreLocationModule = ({locationId}) => {
  return (
    <div style={{width: "100%", height: "100vh" }}>
      {/* <AudioCallPageGrid recipientId={userId} mode={mode}/> */}
    </div>
  );
};

export default ExploreLocationModule;
